// extracted by mini-css-extract-plugin
module.exports = {"status":"Status_status__F4xC6","subStatus":"Status_subStatus__2dnwl"};